import React from 'react';
import { useTranslation } from 'react-i18next';

import s from '../../styles.module.scss';

const PmpmStatusBadge: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div data-cy="criticalReadingsOnly-status-tag" className={s.badge}>
      <p>{t('labels.criticalReadingsOnly')}</p>
    </div>
  );
};
export default PmpmStatusBadge;
